import { deliveryCutoffOverrideOptions } from '@/lib/delivery-cutoff-options'
import { useFormContext } from '@/lib/form-contexts'

const preserveCase = (value) => value

export default function DeliveryCutoffOverrideField({ ariaLabel, label = null, name, size }) {
  const form = useFormContext()

  return (
    <form.AppField name={name}>
      {(field) => (
        <field.SelectInput
          ariaLabel={ariaLabel}
          label={label}
          options={deliveryCutoffOverrideOptions}
          placeholder="Same as location"
          readOnlyEmptyText="Same as location"
          formatReadOnlyValue={preserveCase}
          size={size}
          onValueChange={(value) => {
            if (value === 'location_default') field.handleChange(null)
          }}
        />
      )}
    </form.AppField>
  )
}
